// productutils.js

export const isVariableProduct = (
  product,
) => {
  // PRODUCT PAGE
  if (product?.product_type) {
    return (
      product.product_type ===
      "variable"
    );
  }

  // CART API
  return !!product?.productSkuResponse;
};

export const getProductPrice = (
  product,
  selectedSku = null,
  effectivePrice = null,
) => {
  if (!product) return 0;

  // =========================
  // PRODUCT PAGE
  // =========================
  if (product?.product_type) {
    if (
      product.product_type ===
      "single"
    ) {
      return product.price;
    }

    return (
      selectedSku?.price ??
      product.price
    );
  }

  // =========================
  // CART API
  // =========================
  if (
    product?.productSkuResponse
  ) {
    return (
      effectivePrice ??
      product?.productSkuResponse
        ?.price ??
      0
    );
  }

  return (
    product?.productPrice ||
    product?.ttlPrice ||
    0
  );
};

export const getProductStock = (
  product,
  selectedSku = null,
) => {
  if (!product) return 0;

  // PRODUCT PAGE
  if (product?.product_type) {
    if (
      product.product_type ===
      "single"
    ) {
      return product.stock;
    }

    return (
      selectedSku?.stock ??
      product.stock
    );
  }

  // CART API
  if (
    product?.productSkuResponse
  ) {
    return (
      product
        ?.productSkuResponse
        ?.stock || 0
    );
  }

  return (
    product?.stock || 0
  );
};

export const getProductImage = (
  product,
  selectedSku = null,
) => {
  if (!product) return "";

  // PRODUCT PAGE
  if (product?.product_type) {
    return (
      selectedSku?.imageUrl ||
      product?.thumbnail ||
      ""
    );
  }

  // CART API
  if (
    product?.productSkuResponse
  ) {
    return (
      product
        ?.productSkuResponse
        ?.imageUrl ||
      product?.productImgUrl ||
      ""
    );
  }

  return (
    product?.productImgUrl ||
    ""
  );
};

export const getVariantText = (
  product,
) => {
  const options =
    product?.productSkuResponse
      ?.productSkuOptionResponseList;

  if (
    !options ||
    options.length === 0
  ) {
    return "";
  }

  return options
    .map(
      (item) =>
        `${item?.VariantName}: ${item?.optionValue}`,
    )
    .join(", ");
};

// export const isVariableProduct = (product) =>
//   product?.product_type === "variable";

// export const getProductPrice = (product, selectedSku) => {
//   if (!product) return 0;

//   if (product.product_type === "single") {
//     return product.price;
//   }

//   return selectedSku?.price ?? product.price;
// };

// export const getProductStock = (product, selectedSku) => {
//   if (!product) return 0;

//   if (product.product_type === "single") {
//     return product.stock;
//   }

//   return selectedSku?.stock ?? product.stock;
// };